module.exports = __webpack_public_path__ + "static/img/f1.0bf093c8.png";